import { FormHelperText, SxProps } from '@mui/material';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import { BaseSelectProps } from '@mui/material/Select/Select';
import React from 'react';
import { Resource } from '../../../constants/resource';

export interface FormSelectOption<T> {
  value: T;
  label: string | number;
}

export interface FormSelectProps<T> extends Omit<BaseSelectProps<T>, 'error'> {
  label: string;
  options: FormSelectOption<T>[];
  name: string;
  className?: string;
  isDisabled?: boolean;
  error?: string;
}

const FormSelect = <T,>({
  label,
  options,
  name,
  className,
  isDisabled = false,
  required,
  error,
  ...rest
}: FormSelectProps<T>) => {
  return (
    <FormControl
      size="small"
      placeholder={Resource.SELECT_PLACEHOLDER}
      className={className}
      name={name}
      disabled={isDisabled}
      required={required}
      variant="outlined"
      fullWidth
      error={!!error}
    >
      <InputLabel id={name} shrink>
        {label}
      </InputLabel>
      <Select
        notched
        required={required}
        labelId={name}
        MenuProps={{ disableScrollLock: true }}
        label={label}
        {...rest}
      >
        {options.map((option, index) => (
          <MenuItem key={index} value={option.value as string | number}>
            {option.label}
          </MenuItem>
        ))}
      </Select>
      {error && (
        <FormHelperText sx={sx} error>
          {error}
        </FormHelperText>
      )}
    </FormControl>
  );
};

const sx: SxProps = { marginLeft: 0, marginTop: '0.125rem' };

export default FormSelect;
